<template>
  <div class="text-left py-4" role="separator">
    <span class="font-bold text-base md:text-lg md:pl-12 separator-inner-text text-blue-500">{{ title }}</span>
    <span class="text-xs md:text-sm md:pl-12 separator-description-inner-text" :style="{ color: 'rgba(0, 0, 0, 0.45)' }">
      {{ description }}
      <span class="font-bold text-base separator-inner-icon text-red">{{ symbols }}</span>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Separator extends Vue {
  @Prop({ type: String, default: "", required: true }) title!: string;
  @Prop({ type: String, default: "", required: true }) description!: string;
  @Prop({ type: String, default: "", required: false }) symbols!: string;
}
</script>

<style lang="sass" scoped>
.separator-horizontal
  clear: both
  display: block
  height: 1px
  min-width: 100%
  width: 100%

.separator-horizontal-with-text
  background: transparent
  display: table
  text-align: center
  white-space: nowrap

  &::before,
  &::after
    border-top: 1px solid e8e8e8
    content: ''
    display: table-cell
    position: relative
    transform: translateY(50%)

  &::before
    top: 50%
    width: 5%

  &::after
    top: 50%
    width: 95%

.separator-inner-text
  display: inline-block
  padding: 0 20 0 10px

.separator-description-inner-text
  display: block
</style>
